export default {"src":"/_next/static/media/poster.bfb6a1ed.svg","height":213,"width":1440,"blurWidth":0,"blurHeight":0};